module.exports = __webpack_public_path__ + "media/images/forms-icons/single-select-icon-hover-d241b74d9c46502bb78720127cddf481.svg";